import axios, { AxiosError } from 'axios'
import qs from 'qs'
import { notification } from 'ant-design-vue'

export const api = axios.create({
  baseURL: '/api',
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

api.interceptors.response.use(
  response => response,
  e => {
    showErrorNotification(e)
    return Promise.reject(e)
  }
)

function showErrorNotification(e: AxiosError) {
  if (!e.response) return

  const { data } = e.response
  if (!data) return

  const { error, message, statusCode } = data
  if (!error || !statusCode) return

  notification.error({
    message: `${statusCode} - ${error}`,
    description: typeof message === 'string' ? message : '',
    placement: 'bottomRight',
    icon: h =>
      h('a-icon', {
        props: { type: 'meh' },
        style: { color: '#f5222d' }
      })
  })
}
